import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "stroke-info",
  "use": "stroke-info-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"stroke-info\"><path d=\"M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12\" /><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M5 5h2v5H5zm0-3h2v2H5z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol